import React from 'react';
import {connect} from 'react-redux';
import {deepClone, sortBy} from 'lodash';

// local imports
import api from '../../../store/api'
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import {toggleGlobalLoader, addErrorAlert, addLoadingAlert, removeLoadingAlert} from "../../../store/calls/alertLoadingDispatch";
import validators from "../../../utils/forms/validators";

import Input from "../../theme/forms/Input";
import BaseForm from "../../theme/forms/BaseForm";
import PaginatedTable from "../../theme/tables/PaginatedTable";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import FormModal from "../../theme/modals/FormModal";
import * as preconfiguredInputs from "../../../utils/forms/preconfiguredInputs";
import formatters from "../../../utils/forms/formatters";




class FunderScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            displayedData: [],
            dataPullLimit: 100,
            dataPullOffset: 0,

            // edit and delete
            editModalOpen: false,
            editModalReset: 0,
            deleteModalOpen: false,
            editingInstance: null,



            improvementCategories: [],

            categoryFilter: null,
            nameFilter: null,
        }


        this.baseAPIPath = '/funders/';


        this.createEditInputs =  [
            {
                type: 'text',
                label: "Name",
                dataKey: "name",
            },
            {
                type: 'textarea',
                label: "Description",
                dataKey: "description",
            },
            {
                type: "select",
                label: "If Program allows you to bill directly, when do you start billing?",
                dataKey: "billing_start_type",
                options: this.billingStartTypes
            },
            {
                type: 'text',
                label: "If Annually on a Specific Date, when do you start billing? (M/DD, eg 3/01)",
                dataKey: "annual_payment_start_date",
                ...formatters.date("Mdd",  "LLLL dd"),
            },
            {
                type: 'text',
                label: "If you bill directly, enter how many payments per year you require",
                subLabel: "If payments are matched to pace program, leave blank",
                dataKey: "annual_payment_count",
                ...validators.isNumber
            },
            {
                ...preconfiguredInputs.nullBooleanSelect,
                label: "Accept Refinance",
                dataKey: "refi_ok",
            },
            {
                ...preconfiguredInputs.nullBooleanSelect,
                label: "Does your program allow re-amortization of loan after payment of Investment Tax Credit, in improvements where that applies?" ,
                dataKey: "reamortization_after_tax_credit",
            },
        ]
    }

    componentDidMount() {
        toggleGlobalLoader(true)
        this.getData()
            .catch(() => addErrorAlert("Data load failed"))
            .finally(() => toggleGlobalLoader(false))
    }

    toggleEditModal = () => {
        this.setState({editModalOpen: !this.state.editModalOpen})
    }


    getData = (xtraParams = {}) => {
        let params = {
            limit: this.state.dataPullLimit,
            offset: this.state.dataPullOffset,
            searchVal: this.state.nameFilter,
            category: this.state.categoryFilter,
            ...xtraParams
        }

        return api.get(this.baseAPIPath, params)
            .then(res => {

                let results = res.data.results || [];

                // permissions filter
                if (!this.props.tokenData.admin) {
                    results = results.filter(d => this.props.tokenData.funder_admins.includes(d.id))
                }

                results = results.map(d => ({...d, '_html_name': <a className='has-text-primary' href={`/admin/funders/${d.id}`}>{d.name}</a>}))
                this.setState({displayedData: sortBy(results, ['name'])})
            })
    }

    handleLimitChange = (val) => {
        this.setState({dataPullLimit: val}, this.getData)
    }

    handleOffsetChange = (val) => {
        this.setState({dataPullOffset: val}, this.getData)
    }

    populateInputsWithValues = () => {
        return this.createEditInputs.map(d => ({
            ...d,
            value: this.state.editingInstance ? this.state.editingInstance[d.dataKey] : null
        }))

    }


    handleCreateRequest = (data) => {
         api.post(this.baseAPIPath, data)
            .then((res) => {
                if (this.state.addAnother) {
                    this.setState({editingInstance: null, addAnother: false, editModalReset: this.state.editModalReset + 1});
                    this.getData();
                } else {
                    this.props.history.push('/admin/funders/' + res.data.id);
                }
            })
            .catch(err => console.error(err))
    }


    handleSearch = (val) => {
        this.setState({nameFilter: val},
            this.getData
        )
    }


    render() {
        return (
            <AdminWrapper>
                <div className="section">
                    <div className="container is-fullhd mx-6">
                        <div className="level">
                            <div className="level-left">
                                <div className="level-item">
                                    <h2 className="title is-2">Funder and Product Attributes</h2>
                                </div>
                            </div>
                            <div className="level-right">
                                <div className="level-item">
                                    {this.props.tokenData.admin && <button
                                        className='button is-link'
                                        onClick={() => this.setState({editModalOpen: true})}
                                    >+ Add Funder</button>}
                                </div>
                            </div>
                        </div>
                        <PaginatedTable
                            className="is-fullwidth is-hoverable"
                            data={this.state.displayedData}
                            columns={['name', 'description']}
                            pullLimit={this.state.dataPullLimit}
                            handleLimitChange={this.handleLimitChange}
                            pullOffset={this.state.dataPullOffset}
                            handleOffsetChange={this.handleOffsetChange}
                            handleSearch={this.handleSearch}
                            filterOptions={[]}
                            actions={[]}
                        />
                    </div>
                </div>

                <FormModal
                    title="Create a new Funder"
                    visible={this.state.editModalOpen}
                    inputs={this.populateInputsWithValues()}
                    reset={this.state.editModalReset}
                    disableAutocomplete
                    onSubmit={this.handleCreateRequest}
                    onCancel={() => this.setState({editModalOpen: false, editingInstance: null})}
                    otherButtons={[<button className="button"
                                           type='submit' onClick={(e) => this.setState({addAnother: true})}>
                        Add Another</button>]}
                />

            </AdminWrapper>
        )
    }

}


const mapStateToProps = state => ({
    tokenData: state.user.decodedTokenData
})



export default connect(mapStateToProps)(FunderScreen)
